module.exports = __webpack_public_path__ + "static/img/4mk.1d02314.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/4mk.png
// module id = NvhL
// module chunks = 0